module.exports = __webpack_public_path__ + "img/startup-info-employes-gray.5a8fc327.svg";